import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;

  ${({ theme: { colors, spacing } }) => css`
    padding: ${spacing.level6} ${spacing.level4};
    color: ${colors.onSurfaceVariant};
    gap: ${spacing.level2};
  `}
`;

export const IconCircle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 50%;

  ${({ theme: { colors } }) => css`
    background-color: ${colors.surfaceContainerHighest ?? colors.surfaceContainer};
    color: ${colors.onSurfaceVariant};
  `}
`;

export const Title = styled.div`
  font-size: 14px;
  font-weight: 600;

  ${({ theme: { colors } }) => css`
    color: ${colors.onSurface};
  `}
`;

export const Subtitle = styled.div`
  font-size: 12px;
  max-width: 240px;
`;
